import { Form, Input } from 'antd';
import type { FC } from 'react';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';

import './CopywritingContent.scss';

type CopywritingContentProps = {
  isEditMode: boolean;
};

export const CopywritingContent: FC<CopywritingContentProps> = ({
  isEditMode,
}) => {
  const form = Form.useFormInstance();
  const valueProposition = Form.useWatch('valueProposition', form);
  const description = Form.useWatch('description', form);

  return (
    <div className="copywriting-description">
      <FormLineLayout label="Value proposition">
        <Form.Item name="valueProposition">
          {isEditMode ? (
            <Input type="text" placeholder="Enter value proposition" />
          ) : (
            <span style={{ color: valueProposition ? undefined : '#B3B3B3' }}>
              {valueProposition || '∅ empty'}
            </span>
          )}
        </Form.Item>
      </FormLineLayout>

      <FormLineLayout
        label="Description"
        labelOnTop
        description={
          isEditMode && (
            <div className="description">
              <span>
                You can use - <i>text</i> <b>to create</b> • <i>text</i>
              </span>
            </div>
          )
        }
      >
        <Form.Item name="description">
          {isEditMode ? (
            <Input.TextArea rows={4} placeholder="Enter description" />
          ) : (
            <span style={{ color: description ? undefined : '#B3B3B3' }}>
              {description || '∅ empty'}
            </span>
          )}
        </Form.Item>
      </FormLineLayout>
    </div>
  );
};
